module.exports = __webpack_public_path__ + "static/media/button-right-border-color.589fd710.svg";